module.exports = __webpack_public_path__ + "img/classify_img4.95c6f70d.png";